export function addFinancialSummary(state, payload) {
  state.financialSummaryByYearCustomer[`${payload.year}${payload.customerNumber}`] = payload.financialSummary;
}

export function setIsLoadingFinancialSummary(state, payload) {
  state.isLoadingFinancialSummary = payload;
}
